const avvio_daterange_datepicker = document.querySelectorAll('.js-daterange');
class Avvio_Daterange {
    constructor() {
        this.lang = document.documentElement.lang;
    }

    datepicker_selector() {
        var _self = this
        avvio_daterange_datepicker.forEach(e => {
            _self.init_datepicker(e);
            let card_checkin = e.querySelector('.js-card-checkin'),
                input_checkin = e.querySelector('.js-card-input-checkin'),
                card_checkout = e.querySelector('.js-card-checkout'),
                input_checkout = e.querySelector('.js-card-input-checkout');
                
            const todaysDate = new Date();
            let tomorrowsDate = new Date();
            tomorrowsDate.setDate(todaysDate.getDate() + 1);
            this.buildDateCard(card_checkin, todaysDate);
            this.buildDateCard(card_checkout, tomorrowsDate);
            
            _self.open_calander(card_checkin, input_checkin);
            _self.open_calander(card_checkout, input_checkout);
            _self.target_checkout(e);
        });
    }

    change_date(input_class) {
        input_class.addEventListener('changeDate', function(e) {
            _self.remove_dropdown_class();
        })
    }

    target_checkout(elem) {
        var _self = this;
		let hub_input = elem.querySelectorAll('.js-card-input');
		for ( let hub_item = 0; hub_item < hub_input.length; hub_item++ ) {
			hub_input[hub_item].addEventListener('changeDate', function (evt) { 
				let { inputs } = evt.detail.datepicker.rangepicker,
				dateRangeStartDate = inputs[0],
				dateRangeEndDate = inputs[1],
                newDate;
				if (evt.target == dateRangeStartDate) {
                    setTimeout(() => {
                        dateRangeStartDate.datepicker.setDate(evt.detail.date);
                        var date = evt.detail.date,
                            startDateOnMili = date.getTime();

                        if(startDateOnMili != '') {
                            _self.hoverdateRange(startDateOnMili);
                        }

                        if(dateRangeEndDate.value == '') {       
                            dateRangeEndDate.datepicker.setDate(date.setDate(date.getDate() + 1));
                            newDate = date.getDate();
                        } else {
                            newDate = date.getDate() + 1;
                        }

                        if(dateRangeStartDate.value == dateRangeEndDate.value) {                            
                            dateRangeEndDate.datepicker.setDate(date.setDate(date.getDate() + 1));
                        }

                        dateRangeEndDate.datepicker.show();
                        dateRangeEndDate.datepicker.setOptions({
                            minDate : date.setDate(newDate)
                        });
					}, 50);
				}
                _self.buildDateCard(hub_input[hub_item].parentElement, evt.detail.date);
			});
		}
    }

    hoverdateRange(startDateOnMili) {
        var _self = this;
        avvio_daterange_datepicker.forEach(e => {
            let card_checkout = e.querySelector('.js-card-checkout'),
                items = card_checkout.querySelectorAll('.datepicker__span');
            for (const item of items) {
                item.addEventListener('mouseover', function(e) {
                    let hoverDateOnMili = item.dataset.date;
                    _self.addHoverClass(startDateOnMili, hoverDateOnMili, items);
                })
            }
        });
    }

    addHoverClass(startDateOnMili, hoverDateOnMili, items) {
        for (const item of items) {
            let dateOnMili = item.dataset.date
            if (dateOnMili >= startDateOnMili && dateOnMili <= hoverDateOnMili ) {
                item.classList.add('datepicker--highlight');
            } else {
                item.classList.remove('datepicker--highlight');
            }

        }
    }
    
    buildDateCard(type, date) {
        var _self = this;
        const newCardDate = new Date(date);
        const newCardDay = newCardDate.toLocaleString('default', { day: '2-digit' });
        const newCardMonth = newCardDate.toLocaleString(_self.lang, { month: 'long' });
        const newCardYear = newCardDate.toLocaleString('default', { year: 'numeric' });
        let month = type.querySelector('.js-date-month');
        let day = type.querySelector('.js-date-day');
        let year = type.querySelector('.js-date-year');
        // month.innerHTML = newCardDay +' '+ newCardMonth +' '+ newCardYear;       
        month.innerHTML = newCardMonth;       
        day.innerHTML = newCardDay; 
        if( typeof(year) != 'undefined' && year != null ) {   
            year.innerHTML = newCardYear;    
        }     
    }

    open_calander(click_class, input_class) {
        click_class.addEventListener('click', function() {
            input_class.focus();
        });
    }

    init_datepicker(elem) {
        var _self = this;
        const avvioToday = new Date();
        const dateOptionsRange = {
            maxView : 1,
            minDate : avvioToday, // no dates available before today
            autohide : true,
            todayHighlight : true,
            format : 'yyyy-mm-dd',
            allowOneSidedRange : true,
            nextArrow: '',
            prevArrow: '',
            allowOneSidedRange: true,
            language: _self.lang,
        };

        let datepickerRange = new DateRangePicker(elem, dateOptionsRange); 
    }

    init() {
        this.datepicker_selector();
    }
}
if(avvio_daterange_datepicker.length != 0) {
    const avvio_daterange = new Avvio_Daterange();
    avvio_daterange.init();
}